import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react';
import useGetAvailableLocums from '../hooks/dashboard/directory/useGetAvailableLocums';

interface LocumSearchContextType {
  keyword: string;
  setKeyword: (v: string) => void;
  location: string;
  setLocation: (v: string) => void;
  occupation: string;
  setOccupation: (v: string) => void;
  page: string;
  setPage: (v: string) => void;
  perPage: string;
  setPerPage: (v: string) => void;
  loading: boolean;
}

const LocumSearchContext = createContext<LocumSearchContextType>({
  keyword: '',
  setKeyword: () => {},
  location: '',
  setLocation: () => {},
  occupation: '',
  setOccupation: () => {},
  page: '1',
  setPage: () => {},
  perPage: '10',
  setPerPage: () => {},
  loading: false,
});

export const LocumSearchProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { getAvailableLocums: fetchLocums, loading } = useGetAvailableLocums();

  const [keyword, setKeyword] = useState<string>('');
  const [location, setLocation] = useState<string>('');
  const [occupation, setOccupation] = useState<string>('');
  const [page, setPage] = useState<string>('1');
  const [perPage, setPerPage] = useState<string>('10');

  // 🔥 whenever ANY of these change, run the fetch with the *latest* values
  useEffect(() => {
    fetchLocums({ keyword, location, occupation, page, perPage });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword, location, occupation, page, perPage]);

  return (
    <LocumSearchContext.Provider
      value={{
        keyword,
        setKeyword,
        location,
        setLocation,
        occupation,
        setOccupation,
        page,
        setPage,
        perPage,
        setPerPage,
        loading,
      }}
    >
      {children}
    </LocumSearchContext.Provider>
  );
};

export const useLocumSearch = () => useContext(LocumSearchContext);
